import * as React from "react";
const SvgFiRrAsterik = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-asterik_svg__a)">
      <path
        fill="#062147"
        d="m20.537 12.7-1.13-.7 1.131-.7a4.13 4.13 0 0 0 1.73-2.03 3.92 3.92 0 0 0-3.28-5.273 4.12 4.12 0 0 0-2.587.654l-.4.25v-.729A4.116 4.116 0 0 0 12.392.02 4 4 0 0 0 8 4v.9l-.4-.25a4.12 4.12 0 0 0-2.587-.657 3.918 3.918 0 0 0-3.283 5.27c.336.85.944 1.565 1.73 2.031L4.593 12l-1.13.7a4.13 4.13 0 0 0-1.73 2.031 3.918 3.918 0 0 0 3.286 5.272 4.12 4.12 0 0 0 2.581-.65L8 19.1v.9a4 4 0 0 0 8 0v-.9l.4.251a4.13 4.13 0 0 0 2.58.653 3.918 3.918 0 0 0 3.284-5.272 4.13 4.13 0 0 0-1.727-2.032m-.31 4.418a1.916 1.916 0 0 1-2.64.613l-2.059-1.282A1 1 0 0 0 14 17.3V20a2 2 0 0 1-4 0v-2.7a1 1 0 0 0-1.528-.849l-2.059 1.284a1.92 1.92 0 0 1-2.638-.613 1.916 1.916 0 0 1 .613-2.639l2.625-1.634a1 1 0 0 0 0-1.7L4.388 9.516a1.915 1.915 0 0 1 2.025-3.252l2.06 1.282A1 1 0 0 0 10 6.7V4.107a2.075 2.075 0 0 1 1.664-2.08A2 2 0 0 1 14 4v2.7a1 1 0 0 0 1.528.848l2.06-1.28a1.916 1.916 0 0 1 2.024 3.251l-2.625 1.634a1 1 0 0 0 0 1.7l2.625 1.634a1.913 1.913 0 0 1 .614 2.638z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-asterik_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAsterik;
